import { DocumentType } from '@tcs/client-portal-api/platform_generated';
import { Document } from '@tcs/client-portal-api/types/Documents';
import Table from '@tcs/client-portal-common/components/molecules/Table';
import BaseCell from '@tcs/client-portal-common/components/molecules/Table/cells/BaseCell';
import DownloadCell from '@tcs/client-portal-common/components/molecules/Table/cells/DownloadCell';
import BaseHeader from '@tcs/client-portal-common/components/molecules/Table/cells/headers/BaseHeader';
import { getConfig } from '@tcs/client-portal/config/configService';
import DocumentCell from './DocumentCell';

export interface Props {
  documents?: Document[];
  selectedAccount?: string;
  loading?: boolean;
  selectedYear?: string;
}

export const TaxDetails = ({
  documents,
  selectedAccount,
  loading,
  selectedYear,
}: Props) => {
  if (!documents) {
    return null;
  }
  const currentYear = new Date().getFullYear();

  // only show unavailable documents if All or the current year is selected
  const allDocuments =
    selectedYear === 'All' || currentYear.toString() === selectedYear
      ? [...documents].filter((doc) => doc)
      : documents;

  const columns = [
    {
      accessor: 'year',
      header: () => <BaseHeader text="Tax Year" />,
      cell: (info) => <BaseCell value={info.getValue()} />,
      size: 100,
    },
    {
      accessor: 'taxFormType',
      header: () => <BaseHeader text="Document" />,
      cell: (info) => (
        <DocumentCell
          taxFormType={info.getValue()}
          fileName={info.row.original.fileName}
        />
      ),
      size: 200,
    },
    {
      accessor: 'downloadPath',
      header: () => <BaseHeader text="PDF" />,
      cell: (info) => {
        if (!info.row.original.fileId) {
          return null;
        }
        const url = `${
          getConfig().API_BASE_URL
        }/documents/account/${selectedAccount}/${info.row.original.year}/${
          info.row.original.fileId
        }?type=${DocumentType.TAX}`;

        return <DownloadCell url={url} fileName={info.row.original.fileName} />;
      },
      size: 100,
    },
  ];

  return <Table columns={columns} data={allDocuments} loading={loading} />;
};

export default TaxDetails;
